<template>
  <v-layout row justify-center>
    <v-dialog v-model="checkBrowserDialog" persistent max-width="350" class="pa-3">
      <v-card>
        <!-- <v-card-title class="headline"></v-card-title> -->
        <v-card-text>
          <v-layout column wrap justify-center align-center>
            <v-icon color="#ffbb39" style="font-size: 80px !important;">fas fa-exclamation-circle</v-icon>
            <h3 class="mt-4">{{$t('Alert.CheckOpenNewTab')}}</h3>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <!-- <v-spacer></v-spacer> -->
          <v-layout row wrap justify-center align-center>
            <v-btn color="#2562af" dark rounded @click="open_tab()" class="mr-2">{{$t('AnswerQuestion.ok')}}</v-btn>
            <v-btn color="#2562af" dark rounded outlined @click="close_dialog()">{{$t('AnswerQuestion.cancel')}}</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>


<script>
import { Decode } from '@/services'
export default {
  props: {
    checkBrowserDialog: Boolean,
    checkBrowserInfor: {}
  },
  data () {
    return {
      url: '',
      payload: '',
      token: '',
      data_user: {},
    }
  },
  watch: {
    checkBrowserDialog () {
      if (this.checkBrowserDialog) {
        // console.log(this.checkBrowserInfor)
        // console.log(this.checkBrowserInfor.payload)
        if (this.checkBrowserInfor.payload !== undefined || this.checkBrowserInfor.payload !== null) {
          this.url = this.checkBrowserInfor.url
          this.payload = this.checkBrowserInfor.payload
        } else {
          this.url = this.checkBrowserInfor.url
        }
      }
    }
  },
  methods: {
    open_tab () {
      window.open(this.url, '_blank')
      if (this.checkBrowserInfor.payload !== undefined) {
        if (this.checkBrowserInfor.payload.news_id !== undefined) {
          this.saveLogNews(this.payload)
        }
      }
      this.$emit('closeCheckBrowser', false)
    },
    close_dialog () {
      this.$emit('closeCheckBrowser', false)
    },
    saveLogNews (item) {
      // console.log(item)
      // var user_profile = JSON.parse(this.$cookie.get('user-profile'))
      var user_profile = ''
      if (JSON.parse(this.$cookie.get('user-profile') == null)) {
        user_profile = JSON.parse(localStorage.getItem('user-profile'))
      } else {
        user_profile = JSON.parse(this.$cookie.get('user-profile'))
      }
      this.data_user = user_profile['account']['profile']
      // console.log(one_id)
      this.axios.post(process.env.VUE_APP_API_NEWS, {
        'one_id': this.data_user.one_id,
        'news_id': item.news_id,
        'news_index': item.news_index.toString(),
        'page_name': item.page_name
      }).then((response) => {
        // console.log(response)
      }).catch(error => {
        console.log(error)
      })
    }
  }
}
</script>

<style lang="css" scoped>
>>>.v-sheet.v-card:not(.v-sheet--outlined) {
  padding: 20px !important;
}
</style>
